import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import type { IPaginationDto } from "@dzambalaorg/types-collection";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { FormGrid } from "@dzambalaorg/ui-kit";

export enum ContractEventType {
  WaitListRewardClaimed = "WaitListRewardClaimed", // +
  Claim = "Claim", // +
  Dismantle = "Dismantle", // ???
  Craft = "Craft", // +
  Upgrade = "Upgrade", // +
  Purchase = "Purchase", // +
  PurchaseRaffle = "PurchaseRaffle", // assets; lucky number
  PurchaseLottery = "PurchaseLottery", // assets; numbers - array
  PurchaseMysteryBox = "PurchaseMysteryBox", // assets
  UnpackMysteryBox = "UnpackMysteryBox", // assets
  Transfer = "Transfer", // ERC20,ERC721,ERC998 - no assets
  TransferSingle = "TransferSingle", // ERC1155 // from to assets - no assets
  TransferBatch = "TransferBatch", // ERC1155 // from to assets - no assets
  OwnershipTransferred = "OwnershipTransferred", // Vesting, Extensions // + - no assets
}

export interface IEventSearchDto extends IPaginationDto {
  eventTypes: Array<ContractEventType>;
}

interface ITransactionSearchFormProps {
  initialValues?: IEventSearchDto;
}

export const TransactionSearchForm = (props: ITransactionSearchFormProps) => {
  const { initialValues } = props;

  const { eventTypes = [] } = initialValues || {};
  const fixedValues = { eventTypes };

  return (
    <SearchWithFilters initialValues={fixedValues}>
      <FormGrid columns={[1]}>
        <SelectInput name="eventTypes" options={ContractEventType} multiple />
      </FormGrid>
    </SearchWithFilters>
  );
};
